import React from "react";
import { useTranslation } from "react-i18next";
import {
    StyledModal,
    StyledH2,
    CheckboxIcon,
    StyledLabel,
} from "@aureskonnect/react-ui";
import { ModalBody, ModalFooter, ModalHeader } from "reactstrap";
import { toast } from "react-toastify";
import { mutate } from "swr";
import { useSnapshot } from "valtio";
import { uuid } from "uuidv4";

import { store } from "../../../../components/VerticalLayout/store";
import {
    setIsDataUpdated,
    setKey,
    setIsLoading,
    store as logoStore,
} from "../store";

import { CustomMainColorButton } from "@components/Common/CustomMainColorButton";
import { CustomSecondaryColorButton } from "@components/Common/CustomSecondaryColorButton";

type ConfirmationDeleteMessageType = {
    setIsModalConfirmationOpened: Function;
    isModalConfirmationOpened: boolean;
    setDataIsUpdated: Function;
    selectedRows: any;
    setToastLimit: Function;
};

export function ConfirmationActivePaymentMethod({
    setIsModalConfirmationOpened,
    isModalConfirmationOpened,
    setDataIsUpdated,
    selectedRows,
    setToastLimit,
}: ConfirmationDeleteMessageType) {
    const { t } = useTranslation();
    const { userID, franchiseID, operatorID } = useSnapshot(store);
    const { shopsPaymentMethodsData } = useSnapshot(logoStore);

    const [error, setError] = React.useState(false);
    const uuidUser = localStorage.getItem("uuidUser");

    function ArchivedPaymentMethod(e: any) {
        let idsAssociated = ["0"];
        if (shopsPaymentMethodsData !== undefined) {
            shopsPaymentMethodsData.forEach((element: any) => {
                element.subRows.forEach((el: any) => {
                    if (el.id === e.id) idsAssociated.push(el.idShop);
                });
            });
        }
        idsAssociated = [...new Set(idsAssociated)];

        return idsAssociated;
    }

    async function activePaymentMethod(isValidation: boolean) {
        setIsLoading(true);
        setToastLimit(1);
        toast.dismiss();
        Object.values(selectedRows).forEach(async (element: any) => {
            const id = element.id;
            let shopsArchived = ArchivedPaymentMethod(element);
            let objectData = {
                userId: userID,
                shopId: isValidation ? shopsArchived : ["0"],
                franchiseId: franchiseID,
                operatorId: operatorID,
                uuidUser: uuidUser,
                data: {
                    [id]: {
                        designation: element[t("Type of payment method")],
                        currency: element.Devise,
                        display: element[t("Display name")],
                        shopId: element.idShop,
                        saleSupport: element[t("Support de vente")],
                        country: element[t("Country")],
                        tag: element.Tag,
                        isActive: element.idShop === "0" ? true : false,
                        isArchived: false,
                        languages: element.languages,
                        advancedDisplayName: element.advancedDisplayName,
                    },
                },
            };

            try {
                mutate(
                    `${process.env.REACT_APP_API_V2_URL}/settings/general/paymentMethod`,
                    await fetch(
                        `${process.env.REACT_APP_API_V2_URL}/settings/general/paymentMethod`,
                        {
                            method: "POST",
                            headers: {
                                "Content-Type": "application/json",
                            },
                            body: JSON.stringify(objectData),
                        }
                    ).then((result) => {
                        setDataIsUpdated!(true);
                        setIsDataUpdated(true);
                        setIsLoading(false);
                        setKey(uuid());
                    })
                );
            } catch (e) {
                toast.error(`${t("There's an error")!}`, {
                    position: toast.POSITION.TOP_CENTER,
                    autoClose: 2000,
                    theme: "colored",
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                });
                setError(true);
                setIsLoading(false);
            }
        });
        if (error === false) {
            toast.success(
                `${t("The Payment method is successfully unarchived")!}`,
                {
                    position: toast.POSITION.TOP_CENTER,
                    theme: "colored",
                    icon: <CheckboxIcon height={25} width={25} fill="white" />,
                }
            );
        }
    }

    return (
        <StyledModal toggle={true} isOpen={isModalConfirmationOpened!} centered>
            <ModalHeader
                className="text-capitalize"
                toggle={() => {
                    setDataIsUpdated(true);
                    setIsModalConfirmationOpened(!isModalConfirmationOpened);
                }}
            >
                <StyledH2 className="text-uppercase">{t("Alert")}</StyledH2>
            </ModalHeader>
            <ModalBody>
                <StyledLabel
                    className="pl-3 m-0"
                    style={{ whiteSpace: "pre-line" }}
                >
                    {t(
                        "Attention! the payment method is archived at store level. Do you want to activate it in shops too?"
                    )}
                </StyledLabel>
            </ModalBody>
            <ModalFooter className="border-top-0">
                <CustomSecondaryColorButton
                    outline
                    variant="light"
                    onClick={() => {
                        activePaymentMethod(false);
                        setIsModalConfirmationOpened(
                            !isModalConfirmationOpened
                        );
                    }}
                    rounded
                >
                    {t("Cancel")}
                </CustomSecondaryColorButton>
                <CustomMainColorButton
                    rounded
                    className="mr-2"
                    variant="primary"
                    onClick={() => {
                        activePaymentMethod(true);
                        setIsModalConfirmationOpened(
                            !isModalConfirmationOpened
                        );
                    }}
                >
                    {t("Validate")}
                </CustomMainColorButton>
            </ModalFooter>
        </StyledModal>
    );
}
